  import { withRouter } from 'react-router-dom';
  import WithSystem from '../service/WithSystem';
  const courseSubscriptionFilter = JSON.parse(window.coursesubscriptionactive);
  class CourseSubscriptionStatusDropDown extends React.Component {
    constructor(props) {
      super(props);
      this.box = React.createRef();
      this.state = { dropdownToggle: false }
    }
    setcourseSubscriptionStatusItems = (selectedId, event) => {
      let courseSubscriptionStatus = this.props.queryFilter.courseSubscriptionStatus;
      courseSubscriptionStatus = courseSubscriptionStatus ? courseSubscriptionStatus.split(',') : [];
      if (event.target.checked) {
        courseSubscriptionStatus = courseSubscriptionStatus.length ? [...courseSubscriptionStatus, selectedId] : [selectedId];
      } else {
        courseSubscriptionStatus = courseSubscriptionStatus.filter((branch) => {
          return (branch != selectedId);
        });
      }
      courseSubscriptionStatus = courseSubscriptionStatus.length ? courseSubscriptionStatus.join() : false;
      this.props.setGlobalState({ courseSubscriptionStatus });
    }
    SetDropdownToggleVall = () => {
      this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
        document.addEventListener('click', this.handleOutsideClick);
      });
    }
    handleOutsideClick = (event) => {
      if (this.box && !this.box.current.contains(event.target)) {
        this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
          if (this.state.dropdownToggle == true) {
            this.setState({ dropdownToggle: false });
          }
          document.removeEventListener('click', this.handleOutsideClick);
        });
      }
    }
    
    render() {
      const CourseSubscriptionItems = this.props.queryFilter['courseSubscriptionStatus'] ? this.props.queryFilter['courseSubscriptionStatus'].split(',') : [];
      return (
        <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
          <span className="filter-subtxt">Course Subscription Status</span>
          <div className="report-list-menu" >
            <div className="branch-list-sec">Select Status</div>
            <div className="list_menu_section" >
              <ul className="list_menu">
              {courseSubscriptionFilter.map((course) => {
                let hasChecked = CourseSubscriptionItems.includes(course.id);
                return (
                  <li key={`courseSubscriptionStatus_${course.id}`}><label htmlFor={`courseSubscriptionStatus_${course.id}`}>
                   <span>
                      <input id={`courseSubscriptionStatus_${course.id}`} onClick={(e) => this.setcourseSubscriptionStatusItems(`${course.id}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                    <span className="checkedmark"></span>
                  </span>
                    <span className="dropdownlist_singleline">{course.name}</span></label></li>)
              })}
            </ul>
            </div>
          </div>
        </div>
      );
    }
  }
  export default withRouter(WithSystem(CourseSubscriptionStatusDropDown));
